import React from 'react';
import { useSelector } from 'react-redux';
import { TFunction, useTranslation } from 'react-i18next';
import { getUnsubscribeContactsStore } from '@api/store/suppressions/actions';
import { ContactUnsubscribeMethod, UnsubMethod } from '@dev/ee-api/ee-api-models';
import { isEmpty, map } from 'lodash-es';
import { palette, Tooltip } from '@dev/ee-components';
import { Info } from '@material-ui/icons';
import { PieChartDataType, TooltipLabelAndDescriptionType } from '../../UnsubscribedInterface';
import styled from 'styled-components';

const InfoWrapper = styled.div`
    display: inline-flex;
    svg {
        width: 16px;
        height: 16px;
        color: ${palette.gray[4]};
    }
`;

const chartColor = (index: number) => {
    const chartColor = [palette.pink[4], palette.pink[6], palette.indigo[8], palette.indigo[5], palette.indigo[4]];
    return chartColor[index];
};

const tooltipPieChart = (method: UnsubMethod, t: TFunction): TooltipLabelAndDescriptionType => {
    switch (method) {
        case UnsubMethod.SpamReport:
            return { label: t('viaspamreport'), description: t('viaspamreporttooltip') };
        case UnsubMethod.UnsubscribePage:
            return { label: t('viaunsubscribepage'), description: t('viaunsubscribepagetooltip') };
        case UnsubMethod.ThirdPartyLink:
            return { label: t('viathirdpartylink'), description: t('viathirdpartytooltip') };
        case UnsubMethod.ManualRemoval:
            return { label: t('viamanualremoval'), description: t('viamanualremovaltooltip') };
        case UnsubMethod.UnsubscribeHeader:
            return { label: t('vialistunsubscribeheader'), description: t('vialistunsubscribeheadertooltip') };
        default:
            return { label: '', description: '' };
    }
};

export const usePieChartData = (): PieChartDataType[] => {
    const { t } = useTranslation();
    const { overview } = useSelector(getUnsubscribeContactsStore);

    if (isEmpty(overview)) {
        return [];
    }

    return map(overview?.Methods, (methods: ContactUnsubscribeMethod, index: number) => {
        const tooltipContent = tooltipPieChart(methods.Method, t);

        return {
            name: tooltipContent.label,
            value: methods.Count,
            percent: methods.Rate,
            color: chartColor(index),
            tooltip: (
                <Tooltip
                    id={`tooltip-${index}`}
                    title={tooltipContent.description}
                    color={palette.basic.paper}
                    interactive
                    PopperProps={{ keepMounted: false, disablePortal: true }}
                >
                    <InfoWrapper>
                        <Info fontSize="small" />
                    </InfoWrapper>
                </Tooltip>
            ),
        };
    });
};
